import { useMemo, useState } from 'react';

import { SearchEmptyState } from '@assets/images';
import TableTemplate2 from '@components/tableTemplate2';

import { tableList } from './const';
import { useFilter } from '@pages/UploadSellout/hooks/state/filters';
import { chunk } from 'lodash';
import { useDataKonversi } from '@pages/UploadSellout/hooks/state/useDataKonversi';

const Table = () => {
    const { data: rawData } = useDataKonversi();
    const [sortType, setSortType] = useState();
    const { search, page, limit, setFilter } = useFilter();

    const filteredData = useMemo(() => {
        const searchQuery = search.toLowerCase().trim();
        const combined = [...rawData.failed_data, ...rawData.success_data];
        const filtered = searchQuery
            ? combined.filter(
                  (item) =>
                      item.name?.toLowerCase().includes(searchQuery) ||
                      item.barcode?.toLowerCase().includes(searchQuery),
              )
            : combined;

        if (!sortType) return filtered;

        return filtered.toSorted((a, b) => {
            const valueA = a[sortType.name];
            const valueB = b[sortType.name];
            if (typeof valueA === 'number' && typeof valueB === 'number') {
                return sortType.type === 'asc' ? valueA - valueB : valueB - valueA;
            }
            const fieldA = String(valueA ?? '');
            const fieldB = String(valueB ?? '');
            return sortType.type === 'asc' ? fieldA.localeCompare(fieldB) : fieldB.localeCompare(fieldA);
        });
    }, [rawData, search, sortType]);

    const data = useMemo(() => chunk(filteredData, limit), [filteredData, limit]);
    const dataCount = filteredData.length;
    const totalPage = Math.ceil(dataCount / limit);

    const handlePageClick = ({ selected }) => {
        setFilter({ page: selected + 1 });
    };

    const onChangeLimit = (e) => {
        setFilter({ limit: Number(e.target.value), page: 1 });
    };

    return (
        <TableTemplate2
            isLoading={false}
            data={data[page - 1] || []}
            tableList={tableList}
            totalData={dataCount}
            totalPage={totalPage}
            handlePageClick={handlePageClick}
            isPagination
            isDynamicTable={false}
            isSearch={search}
            page={page}
            limit={limit}
            onChangeLimit={onChangeLimit}
            sortType={sortType}
            noResultSearchImage={<SearchEmptyState />}
            description={<>Daftar produk tidak ditemukan</>}
            emptyStateBottomComponent={null}
            onClickByRow={null}
            selectedRow={[]}
            onChangeBulkCheckbox={null}
            onCheckAllRow={null}
            onSort={(value) => {
                if (sortType?.name === value) {
                    setSortType({ type: sortType.type === 'desc' ? 'asc' : 'desc', name: value });
                } else {
                    setSortType({ type: 'desc', name: value });
                }
            }}
        />
    );
};

export default Table;
